// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-page__toc {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 0.75rem;
  margin: 0 0 1.5rem;
}

.help-page__toc a {
  padding: 0.4rem 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
  color: var(--color-text);
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
}

.help-page__toc a:hover {
  border-color: var(--color-accent);
  background: var(--color-accent-soft);
  color: var(--color-accent);
}

.help-page__content {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.help-page__section {
  padding: 1.15rem 1.2rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow);
  scroll-margin-top: 1.25rem;
}

.help-page__section h3 {
  margin: 0 0 0.75rem;
  font-size: 1.1rem;
  font-weight: 700;
}

.help-page__section h4 {
  margin: 1rem 0 0.5rem;
  font-size: 0.95rem;
  font-weight: 700;
}

.help-page__section p,
.help-page__section li {
  color: var(--color-text);
  font-size: 0.92rem;
  line-height: 1.55;
}

.help-page__section p {
  margin: 0 0 0.75rem;
}

.help-page__section ol,
.help-page__section ul {
  margin: 0;
  padding-left: 1.25rem;
}

.help-page__section li + li {
  margin-top: 0.4rem;
}

.help-page__section a {
  color: var(--color-accent);
  font-weight: 600;
}

.help-page__section code {
  padding: 0.1rem 0.35rem;
  border-radius: 4px;
  background: var(--color-accent-soft);
  font-size: 0.85em;
}

.help-page__btn {
  display: inline-flex;
  align-items: center;
  padding: 0.55rem 0.95rem;
  border: none;
  border-radius: var(--radius);
  background: var(--color-btn);
  color: var(--color-btn-text) !important;
  font: inherit;
  font-size: 0.88rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}

.help-page__btn:hover:not(:disabled) {
  filter: brightness(1.05);
}

.help-page__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.help-page__btn--secondary {
  background: var(--color-surface);
  color: var(--color-text) !important;
  border: 1px solid var(--color-border);
}

.help-page__btn--secondary:hover:not(:disabled) {
  border-color: var(--color-accent);
  background: var(--color-accent-soft);
  color: var(--color-accent) !important;
  filter: none;
}

.help-page__downloads {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin: 0 0 1rem;
}

.help-page__template-notes {
  margin: 0;
  padding-left: 1.25rem;
}

.help-page__template-notes li + li {
  margin-top: 0.35rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Help.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;EAChC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,4BAA4B;EAC5B,uCAAuC;EACvC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,4BAA4B;EAC5B,4BAA4B;EAC5B,uCAAuC;EACvC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".help-page__toc {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 0.75rem;\n  margin: 0 0 1.5rem;\n}\n\n.help-page__toc a {\n  padding: 0.4rem 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n  color: var(--color-text);\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.help-page__toc a:hover {\n  border-color: var(--color-accent);\n  background: var(--color-accent-soft);\n  color: var(--color-accent);\n}\n\n.help-page__content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.help-page__section {\n  padding: 1.15rem 1.2rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface-raised);\n  box-shadow: var(--shadow);\n  scroll-margin-top: 1.25rem;\n}\n\n.help-page__section h3 {\n  margin: 0 0 0.75rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n.help-page__section h4 {\n  margin: 1rem 0 0.5rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.help-page__section p,\n.help-page__section li {\n  color: var(--color-text);\n  font-size: 0.92rem;\n  line-height: 1.55;\n}\n\n.help-page__section p {\n  margin: 0 0 0.75rem;\n}\n\n.help-page__section ol,\n.help-page__section ul {\n  margin: 0;\n  padding-left: 1.25rem;\n}\n\n.help-page__section li + li {\n  margin-top: 0.4rem;\n}\n\n.help-page__section a {\n  color: var(--color-accent);\n  font-weight: 600;\n}\n\n.help-page__section code {\n  padding: 0.1rem 0.35rem;\n  border-radius: 4px;\n  background: var(--color-accent-soft);\n  font-size: 0.85em;\n}\n\n.help-page__btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.55rem 0.95rem;\n  border: none;\n  border-radius: var(--radius);\n  background: var(--color-btn);\n  color: var(--color-btn-text) !important;\n  font: inherit;\n  font-size: 0.88rem;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.help-page__btn:hover:not(:disabled) {\n  filter: brightness(1.05);\n}\n\n.help-page__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.help-page__btn--secondary {\n  background: var(--color-surface);\n  color: var(--color-text) !important;\n  border: 1px solid var(--color-border);\n}\n\n.help-page__btn--secondary:hover:not(:disabled) {\n  border-color: var(--color-accent);\n  background: var(--color-accent-soft);\n  color: var(--color-accent) !important;\n  filter: none;\n}\n\n.help-page__downloads {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n  margin: 0 0 1rem;\n}\n\n.help-page__template-notes {\n  margin: 0;\n  padding-left: 1.25rem;\n}\n\n.help-page__template-notes li + li {\n  margin-top: 0.35rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
